import React from 'react';
import MainLayout from '../components/MainLayout';

export default function OurValues() {
  return (

    <>
    <MainLayout>

    <div className='container'>

        <div className='row'>
        <div className='col-12'>
        OurValues
        </div>
        </div>

    </div>

    </MainLayout>
    </>

  )
}
